export default __webpack_public_path__ + "static/media/O-054.ed39f6b4.png";